
import { Vue, Component, Prop } from "vue-property-decorator";

import dayGridPlugin from "@fullcalendar/daygrid";
import deLocale from "@fullcalendar/core/locales/de";
import FullCalendar from "@fullcalendar/vue";
import {
  CalendarOptions,
  EventInput,
  EventSourceFuncArg,
} from "@fullcalendar/core";
import { Station } from "@/api/dtos/Station.schema";
import { getUtilization } from "@/api/stations";

@Component({
  components: {
    FullCalendar,
  },
})
export default class MonthlyUtilizationView extends Vue {
  @Prop()
  station!: Station;

  @Prop()
  deviceType!: string | null;

  calendarOptions: CalendarOptions = {
    plugins: [dayGridPlugin],
    initialView: "dayGridMonth",
    events: this.fetchData,
    locales: [deLocale],
    locale: "de",
    firstDay: 1,
    buttonText: { today: "Heute" },
  };

  stripTimeUtc(date: Date): Date {
    return new Date(date.toDateString());
  }

  addDays(date: Date, count: number): Date {
    const next = new Date(date);
    next.setDate(next.getDate() + count);
    return next;
  }

  async fetchData(info: EventSourceFuncArg): Promise<EventInput[]> {
    const utilization = await getUtilization(
      this.station.uuid,
      info.start,
      info.end,
      this.deviceType
    );

    var events: EventInput[] = [];

    const devices = this.station.devices;

    var currentDate = info.start;

    const endTime = info.end.getTime();

    const lowCapacity = devices.length * 0.25;

    const deviceCount =
      this.deviceType == null
        ? devices.length
        : devices.filter((d) => d.typeSettings.assignedType === this.deviceType)
            .length;

    while (currentDate.getTime() < endTime) {
      var capacity = deviceCount;

      for (var i in utilization) {
        const current = utilization[i];

        const startDate = new Date(current.start);
        const endDate = new Date(current.end);

        const adjustedStart = this.stripTimeUtc(startDate);
        const adjustedEnd = this.stripTimeUtc(endDate);

        if (
          currentDate.getTime() >= adjustedStart.getTime() &&
          currentDate.getTime() <= adjustedEnd.getTime()
        ) {
          capacity -= 1;
        }
      }

      if (capacity < 0) {
        capacity = 0;
      }

      var eventColor = "bpbPrimary";

      if (capacity < lowCapacity) {
        eventColor = "bpbDanger";
      }

      events.push({
        start: currentDate,
        end: currentDate,
        allDay: true,
        title: `${capacity} verfügbar`,
        className: eventColor,
      });

      currentDate = this.addDays(currentDate, 1);
    }

    return events;
  }
}
